import MessagePanelHeader from "./message-panel-header";

export default MessagePanelHeader;
